import { render, staticRenderFns } from "./FivGoalForm.vue?vue&type=template&id=248cc4ed&scoped=true"
import script from "./FivGoalForm.vue?vue&type=script&lang=ts"
export * from "./FivGoalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cc4ed",
  null
  
)

export default component.exports